import _ from "lodash";

export * from "./buildTime";
export type Environment = "development" | "staging" | "production";
export type RemoteConfig = Record<
    "SOLR_USERNAME" | "SOLR_PASSWORD" | "AUTH0_DOMAIN" | "AUTH0_CLIENT_ID" | "AUTH0_TOKEN_EXPIRY" | "CAPTCHA_SITE_KEY",
    null | string
>;
const ENV = process.env.REACT_APP_NODE_ENV as Environment;

const drupalEndpoint = ENV === "development" ? process.env.REACT_APP_DRUPAL_ENDPOINT : `${window.location.origin}`;

const mapApi = ENV === "development" ? process.env.REACT_APP_MAP_API : `${window.location.origin}/api`;

const tileApi = ENV === "development" ? process.env.REACT_APP_TILE_API : `${window.location.origin}/api/vector`;

const graphQLEndpoint =
    ENV === "development" ? process.env.REACT_APP_DRUPAL_GRAPHQL_ENDPOINT : `${window.location.origin}/api/graphql/app`;

const kpiOpenDataEndpoint =
    ENV === "development" ? process.env.REACT_APP_OPENDATA_ENDPOINT : `${window.location.origin}/api/opendata`;

const solrEndpoint =
    ENV === "development" ? process.env.REACT_APP_SOLR_ENDPOINT : `${window.location.origin}/solr/solr/drupal`;

export const Config: {
    geoEncodingEndpoint: string;
    solrEndpoint: string;

    domWatcher: boolean;
    mainAppStart: boolean;
    drupalComponentInject: boolean;
    isGraphQLAPQ: boolean;

    graphQLEndpoint: string;
    drupalEndpoint: string;
    mapApi: string;
    tileApi: string;
    solrUsername: string;
    solrPassword: string;
    kpiOpenDataEndpoint: string;
    kpiOpenDataId: string;

    protect: boolean;

    auth0Domain: string;
    auth0ClientId: string;
    auth0TokenExpiry: number;
    captchaSiteKey: string;
    solrHasCredentials: boolean;
} = {
    geoEncodingEndpoint: process.env.REACT_APP_GEO_ENCODING_ENDPOINT,
    solrEndpoint,
    kpiOpenDataEndpoint,
    kpiOpenDataId: "7ea7771a-5713-4630-9c4d-3cbbd4034b4c",
    protect: process.env.REACT_APP_PROTECT?.trim() === "true" ? true : false,

    domWatcher: `${process.env.REACT_APP_DOM_WATCHER}`.toLowerCase() === "true",
    mainAppStart: `${process.env.REACT_APP_MAIN_APP_START}`.toLowerCase() === "true",
    drupalComponentInject: `${process.env.REACT_APP_DRUPAL_COMP_INJECT}`.toLowerCase() === "true",
    isGraphQLAPQ: `${process.env.REACT_APP_GRAPHQL_APQ}`.toLowerCase() === "true",

    graphQLEndpoint,
    drupalEndpoint,
    mapApi,
    tileApi,

    solrUsername: "",
    solrPassword: "",
    auth0Domain: "",
    auth0ClientId: "",
    auth0TokenExpiry: 0,
    captchaSiteKey: "",
    solrHasCredentials: false
};

export const setupConfig = (remoteConfig: RemoteConfig) => {
    const solrUsername = ENV === "development" ? process.env.REACT_APP_SOLR_USERNAME : remoteConfig.SOLR_USERNAME;

    const solrPassword = ENV === "development" ? process.env.REACT_APP_SOLR_PASSWORD : remoteConfig.SOLR_PASSWORD;

    const auth0Domain = ENV === "development" ? process.env.REACT_APP_AUTH0_DOMAIN : remoteConfig.AUTH0_DOMAIN;

    const auth0ClientId = ENV === "development" ? process.env.REACT_APP_AUTH0_CLIENT_ID : remoteConfig.AUTH0_CLIENT_ID;

    const auth0TokenExpiry =
        ENV === "development" ? process.env.REACT_APP_AUTH0_TOKEN_EXPIRY : remoteConfig.AUTH0_TOKEN_EXPIRY;

    const captchaSiteKey =
        ENV === "development" ? process.env.REACT_APP_CAPTCHA_SITE_KEY : remoteConfig.CAPTCHA_SITE_KEY;

    const _Config = {
        // solrEndpoint: process.env.REACT_APP_SOLR_ENDPOINT,

        // graphQLEndpoint: process.env.REACT_APP_DRUPAL_GRAPHQL_ENDPOINT,
        // graphQLEndpoint: "http://localhost:4000/graphql",

        // drupalEndpoint: process.env.REACT_APP_DRUPAL_ENDPOINT,

        // mapApi: `${process.env.REACT_APP_MAP_API}`,
        mapApi,

        // tileApi: `${process.env.REACT_APP_TILE_API}`,
        tileApi,

        // solrUsername: `${process.env.REACT_APP_SOLR_USERNAME}`,
        solrUsername,

        // solrPassword: `${process.env.REACT_APP_SOLR_PASSWORD}`,
        solrPassword,

        // kpiOpenDataEndpoint: `${process.env.REACT_APP_OPENDATA_ENDPOINT}`,

        //"https://www.data.qld.gov.au/api/3/action/datastore_search_sql",

        // auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN,
        auth0Domain,

        // auth0ClientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
        auth0ClientId,

        // auth0TokenExpiry:
        //     (process.env.REACT_APP_AUTH0_TOKEN_EXPIRY ?? "").trim() === ""
        //         ? undefined
        //         : parseFloat(process.env.REACT_APP_AUTH0_TOKEN_EXPIRY),
        auth0TokenExpiry:
            `${auth0TokenExpiry ?? ""}`.trim() === "" ? undefined : parseFloat(`${auth0TokenExpiry ?? ""}`),

        // captchaSiteKey: process.env.REACT_APP_CAPTCHA_SITE_KEY
        captchaSiteKey
    };

    const solrHasCredentials =
        _Config.solrUsername != null &&
        _Config.solrUsername.trim() !== "" &&
        _Config.solrPassword != null &&
        _Config.solrPassword.trim() !== "";

    _.merge(Config, {
        ..._Config,
        solrHasCredentials
    });
};
